<template>
  <b-navbar toggleable="lg" fixed="top" id="main-nav" type="dark" class="navbar-custom">
    <b-navbar-toggle target="nav_collapse" />

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item>
          <router-link tag="a" to="/" class="non-dropdown-item">
            <span class="dhn-home-icon">
              <i class="fas fa-home fa-sm"></i>
            </span>
            <span class>{{ navigation.home.navTitle[lang] }}</span>
          </router-link>
        </b-nav-item>
        <b-nav-item-dropdown :text="navigation.info.navTitle[lang]">
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/themen/kulturstiftung-sibirien')"
          >{{ navigation.kss.navTitle[lang] }}</router-link>
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/themen/partner')"
          >{{ navigation.partner.navTitle[lang] }}</router-link>
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/impressum')"
          >{{ navigation.impressum.navTitle[lang] }}</router-link>
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/datenschutzerklaerung')"
          >{{ navigation.datenschutzerklaerung.navTitle[lang] }}</router-link>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown :text="navigation.ethnografies.navTitle[lang]">
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/ethnien')"
          >{{ navigation.allEthnografies.navTitle[lang] }}</router-link>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown :text="navigation.allSubjects.navTitle[lang]">
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/themenseite')"
          >{{ navigation.allSubjects.navTitle[lang] }}</router-link>
          <router-link
            v-for="(subject, index) in subjects"
            :key="index"
            tag="b-dropdown-item"
            :to="getPath(`/themen/${subject.slug}`)"
          >{{ subject.titel }}</router-link>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown :text="navigation.verlag.navTitle[lang]">
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/verlag')"
          >{{ navigation.verlag.navTitle[lang] }}</router-link>
          <router-link
            v-for="(section, index) in dlSections"
            :key="index"
            tag="b-dropdown-item"
            :to="getPath(`/verlag/${section.slug}`)"
          >{{ section.titel }}</router-link>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown :text="navigation.sammlungen.navTitle[lang]">
          <router-link
            tag="b-dropdown-item"
            :to="getPath('/sammlungen')"
          >{{ navigation.sammlungen.navTitle[lang] }}</router-link>
          <router-link
            v-for="(sammlung, index) in sammlungen"
            :key="index"
            tag="b-dropdown-item"
            :to="getPath(`${sammlung.link}`)"
          >{{ sammlung.titel }}</router-link>
        </b-nav-item-dropdown>
        <!-- <b-nav-item>
          <router-link
            tag="a"
            :to="getPath('/medien/videos')"
            class="non-dropdown-item"
          >{{ navigation.videos.navTitle[lang] }}</router-link>
        </b-nav-item> -->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- Platzhalter Suche
        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search" />
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>
        -->
        <b-nav-item-dropdown :text="navigation.langSwitch[lang]" right>
          <b-dropdown-item
            href="#"
            @click="switchLanguage('de')"
           >
           DE
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="switchLanguage('en')"
           >
           EN
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="switchLanguage('ru')"
          >
           RU
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="localizationRedirect()"
          >
           JP
          </b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="localizationRedirect()"
          >
           FR
          </b-dropdown-item>
          <!-- <b-dropdown-item
            href="#"
            @click="switchLanguage('de')"
           >
           DE
          </b-dropdown-item>-->
        </b-nav-item-dropdown>-->
        <!-- Platzhalter dropdown
        <b-nav-item-dropdown right>
          <template slot="button-content"><em>User</em></template>
          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item href="#">Signout</b-dropdown-item>
        </b-nav-item-dropdown>-->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'navbar',
  data () {
    return {

    }
  },
  methods: {
    ...mapActions(['switchLanguage']),
    localizationRedirect () {
      // provisorische Umleitung auf Localization-Seite
      this.$router.push('/localization/' + this.lang)
    },
    // fetchData () {},
    navTitel (slug) {
      let navTitel = ''
      if (typeof this.navTitles !== 'undefined') {
        let obj = this.navTitles.find(t => t.slug === slug)
        if (obj) {
          navTitel = obj.navTitel
        }
      }
      return navTitel
    }
  },
  computed: {
    ...mapGetters({
      navigation: 'getNavigation',
      subjects: 'getSubjectsData',
      dlSections: 'getDLSectionsData',
      lang: 'getLanguage',
      navTitles: 'getNavTitles'
    }),
    sammlungen () {
      return [
        {
          titel: this.navigation.dossiers.navTitle[this.lang],
          link: '/medien/dossiers'
        },
        {
          titel: this.navigation.digitaleBibliothek.navTitle[this.lang],
          link: '/bibliothek/digitales'
        },
        {
          titel: this.navigation.videos.navTitle[this.lang],
          link: '/medien/videos'
        },
        {
          titel: this.navigation.fotos.navTitle[this.lang],
          link: '/medien/fotos'
        },
        {
          titel: this.navigation.ethnographica.navTitle[this.lang],
          link: '/medien/ethnographica'
        },
        {
          titel: this.navigation.buecher.navTitle[this.lang],
          link: '/bibliothek/buecher'
        },
        // {
        //   titel: this.navigation.autographen.navTitle[this.lang],
        //   link: '/bibliothek/autographen'
        // },
        {
          titel: this.navigation.weitereDigitalisate.navTitle[this.lang],
          link: '/bibliothek/diverse-digitalisate'
        }

      ]
    }
  },
  created () {
    // this.fetchData()
  }
}
</script>

<style lang="scss">
</style>
